// extracted by mini-css-extract-plugin
export default {"main":"settings_main__HX19x"};